"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEPropertiesDetails = void 0;
const ArticleProperties_1 = require("../ArticleProperties");
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * AE properties that are used by the individual applications detail requests.
 */
class AEPropertiesDetails {
}
exports.AEPropertiesDetails = AEPropertiesDetails;
_a = echain_shared_igus_fundamentals_1.AppName.EIQ, _b = echain_shared_igus_fundamentals_1.AppName.EKE, _c = echain_shared_igus_fundamentals_1.AppName.EIC, _d = echain_shared_igus_fundamentals_1.AppName.ECF;
AEPropertiesDetails[_a] = ArticleProperties_1.ALL_ARTICLE_PROPERTIES;
AEPropertiesDetails[_b] = ArticleProperties_1.ALL_ARTICLE_PROPERTIES;
AEPropertiesDetails[_c] = ArticleProperties_1.ALL_ARTICLE_PROPERTIES;
AEPropertiesDetails[_d] = ArticleProperties_1.ALL_ARTICLE_PROPERTIES;
//# sourceMappingURL=AEPropertiesDetails.js.map